// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"01dee1a6","99":"fef20e9a","146":"4c8603ed","175":"32a5dcab","204":"ba6bb1d3","349":"3c533a20","453":"c2b3796d","479":"48fdc770","655":"e4daf952","674":"99c833fc","768":"5bafb3a4","813":"b2002f81","963":"85663e0e"}[chunkId] + ".chunk.js";
};